export const messages = {
  page: {
    header: {
      id: 'appointments.Page.Header',
      defaultMessage: 'Appointments',
    },
  },
  columns: {
    id: {
      id: 'appointments.Columns.Id',
      defaultMessage: 'ID',
    },
    date: {
      id: 'appointments.Columns.Date',
      defaultMessage: 'Date',
    },
    type: {
      id: 'appointments.Columns.Type',
      defaultMessage: 'Type',
    },
    provider: {
      id: 'appointments.Columns.Provider',
      defaultMessage: 'Care Provider',
    },
    location: {
      id: 'appointments.Columns.Location',
      defaultMessage: 'Location',
    },
    status: {
      id: 'appointments.Columns.Status',
      defaultMessage: 'Status',
    },
  },
  statements: {
    preference: {
      id: 'appointments.Statements.Preference',
      defaultMessage: 'Notifications Settings: {patientNotifPref}',
    },
    timezone: {
      id: 'appointments.Statements.Timezone',
      defaultMessage: 'Appointment time is shown in {facilityTimeZone} unless otherwise specified.',
    },
    noAppointments: {
      id: 'appointments.Statements.NoAppointments',
      defaultMessage: 'No items to display',
    },
    noApptsMatchFilter: {
      id: 'appointments.Filter.NoApptsMatchFilter',
      defaultMessage: 'No appointments match your filter selections.',
    },
  },
  filter: {
    date: {
      id: 'appointments.Filter.Date',
      defaultMessage: 'Date',
    },
    provider: {
      id: 'appointments.Filter.Provider',
      defaultMessage: 'Care Provider',
    },
    status: {
      id: 'appointments.Filter.Status',
      defaultMessage: 'Appointment Status',
    },
    appointmentType: {
      id: 'appointments.Filter.AppointmentType',
      defaultMessage: 'Appointment Type',
    },
    filterMessage: {
      id: 'appointments.Filter.FilterMessage',
      defaultMessage: 'Showing {filteredRows} of {allRows}{rowItemName}',
    },
    appointments: {
      id: 'appointments.Filter.Appointments',
      defaultMessage: 'appointments',
    },
    clearFilter: {
      id: 'appointments.Filter.ClearFilter',
      defaultMessage: 'Clear Filters',
    },
    allDates: {
      id: 'appointments.Filter.AllDates',
      defaultMessage: 'All',
    },
    upcomingDates: {
      id: 'appointments.Filter.UpcomingDates',
      defaultMessage: 'Upcoming',
    },
    pastDates: {
      id: 'appointments.Filter.PastDates',
      defaultMessage: 'Past',
    },
    allCareProviders: {
      id: 'appointments.Filter.AllCareProviders',
      defaultMessage: 'All care providers',
    },
    allStatuses: {
      id: 'appointments.Filter.AllStatuses',
      defaultMessage: 'All statuses',
    },
    allTypes: {
      id: 'appointments.Filter.AllTypes',
      defaultMessage: 'All types',
    },
  },
  notifPreference: {
    FieldName: {
      id: 'appointments.Preference.FieldName',
      defaultMessage: 'appointment date',
    },
  },
};
